export interface ILocationMessageRequest {
    message: { [key: string]: string };
}
